import React from 'react'

import CheckedSvg from 'components/atoms/SVGIcons/Checked'

const Checkbox = ({ children, className = '', disabled = false, checked = false, id, name, onChange }) => (
  <>
    <label className={className}>
      <input
        id={id}
        name={name}
        className="checkbox"
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      <div className="new-checkbox-indicator">
        <CheckedSvg />
      </div>
      {children}
    </label>
    <style jsx>
      {`
        display: flex;
        margin: 8px 0;
        .new-checkbox-indicator {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
          border-radius: 4px;
          background-color: #fff;
          border: solid 1px #D3DCE6;
          width: 16px;
          height: 16px;
        }

        input[type='checkbox'] {
          display: none;
          &:not(:checked) + .new-checkbox-indicator {
            background-image: none;
          }

          &:checked:not(:disabled) + .new-checkbox-indicator {
            background-color: #00C2C9;
            border: solid 1px #00C2C9 !important;
          }

          &:hover {
            &:not(:disabled) + .new-checkbox-indicator {
              border: solid 1px #7D92A9 !important;
            }
            &:checked + .new-checkbox-indicator {
              border: solid 1px #00C2C9 !important;
            }
          }

          &:disabled + .new-checkbox-indicator {
            border: solid 1px #D3DCE6;
            background-color: #EBEEF3;
          }
        }
      `}
    </style>
  </>
)

export default Checkbox
